import React from "react";

import BorderedTwoImageRow from "@sendmagic/prismic-nextjs/src/components/TwoImageRow/variations/Bordered";
import DefaultTwoImageRow from "@sendmagic/prismic-nextjs/src/components/TwoImageRow/variations/Default";

const BORDERED_TYPE = "bordered";

const TwoImageRow = ({ doc, ...rest }) => {
  const { slice_label } = doc;
  return slice_label === BORDERED_TYPE ? (
    <BorderedTwoImageRow doc={doc} {...rest} />
  ) : (
    <DefaultTwoImageRow doc={doc} {...rest} />
  );
};

export default TwoImageRow;
